module.exports = __webpack_public_path__ + "img/1531938150.49666afb.jpg";